import usersQueries from '@/api/modules/usersQueries'
import { t } from '@/i18n'
import { notificationService } from '@/services/notificationService'
import { handleApiError } from '@/utils/apiHelpers'

class UsersService {
    async fetchUsers(queryString = '') {
        try {
            return await usersQueries.fetchUsers(queryString)
        } catch (error) {
            handleApiError(error, t('administration.users.notifications.fetchUsersError'))
            throw error
        }
    }

    async fetchUserById(userId) {
        try {
            return await usersQueries.fetchUserById(userId)
        } catch (error) {
            handleApiError(error, t('administration.users.notifications.fetchUserError'))
            throw error
        }
    }

    async createUser(userData) {
        try {
            const response = await usersQueries.createUser(userData)
            notificationService.success(t('administration.users.notifications.userCreated'))
            return response
        } catch (error) {
            handleApiError(error, t('administration.users.notifications.userCreationError'))
            throw error
        }
    }

    async updateUser(userId, userData) {
        try {
            const response = await usersQueries.updateUser(userId, userData)
            notificationService.success(t('administration.users.notifications.userUpdated'))
            return response
        } catch (error) {
            handleApiError(error, t('administration.users.notifications.userUpdateError'))
            throw error
        }
    }

    async getProductionDepartments(query = '') {
        try {
            return await usersQueries.getProductionDepartments(query)
        } catch (error) {
            handleApiError(error, t('administration.users.notifications.fetchProductionDepartmentsError'))
            throw error
        }
    }

    async getStopCardProductionDepartments(query = '') {
        try {
            return await usersQueries.getStopCardProductionDepartments(query)
        } catch (error) {
            handleApiError(error, t('administration.users.notifications.fetchStopCardProductionDepartmentsError'))
            throw error
        }
    }

    async getUserPositions() {
        try {
            return await usersQueries.getUserPositions()
        } catch (error) {
            handleApiError(error, t('administration.users.notifications.fetchUserPositionsError'))
            throw error
        }
    }

    async getUserSquads() {
        try {
            return await usersQueries.getUserSquads()
        } catch (error) {
            handleApiError(error, t('administration.users.notifications.fetchUserSquadsError'))
            throw error
        }
    }

    async getUserRoles() {
        try {
            return await usersQueries.getUserRoles()
        } catch (error) {
            handleApiError(error, t('administration.users.notifications.fetchUserRolesError'))
            throw error
        }
    }

    async findUsers(paginate, query) {
        try {
            return await usersQueries.findUsers(paginate, query)
        } catch (error) {
            handleApiError(error, t('administration.users.notifications.searchUsersError'))
            throw error
        }
    }

    async findActiveUsers(paginate, query) {
        try {
            return await usersQueries.findActiveUsers(paginate, query)
        } catch (error) {
            handleApiError(error, t('administration.users.notifications.searchActiveUsersError'))
            throw error
        }
    }

    async receiveUsers(paginate, query, search) {
        try {
            return await usersQueries.receiveUsers(paginate, query, search)
        } catch (error) {
            handleApiError(error, t('administration.users.notifications.searchUsersError'))
            throw error
        }
    }
}

export const useUsersService = () => new UsersService()
